<template lang="pug">
  div
    //- タイトル
    div(v-if="info.title")
      div(v-if="info.subTitle")|{{info.subTitle}}
      strong.title
        template(v-if="info.route")
          a(href="#" @click="$router.push(info.route)")|{{info.title}}
        template(v-else)
          |{{info.title}}

    //- 詳細情報
    div(v-if="info.startTime && info.endTime")
      |{{info.startTime | time}} ～ {{info.endTime | time}}
</template>

<script>
export default {
  props: {
    info: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="sass" scoped>
.title
  font-size: 1.4rem
</style>
